export function IdsGenerator({
  prefix,
  id,
  suffix: suffix,
}: {
  prefix: string;
  id: string;
  suffix?: string;
}) {
  const newPrefix = prefix?.toLowerCase().split(" ").join("-");
  const newId =
    id?.split(" ").length > 1
      ? id
          ?.toLowerCase()
          .split(" ")
          .map((word) => (word.length > 1 ? word : ""))
          .join("-")
      : id?.toLowerCase().split(" ").join("-");

  const newsuffix = suffix?.toLowerCase().split(" ").join("-");

  if (newPrefix && newId && newsuffix) {
    return `${newPrefix}-${newId}-${newsuffix}`;
  } else if (newPrefix && newId) {
    return `${newPrefix}-${newId}`;
  } else {
    return `${newId}`;
  }
}
